const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0.742 17.88C0.91 17.712 1.12 17.628 1.372 17.628C1.624 17.628 1.834 17.712 2.002 17.88C2.17 18.06 2.254 18.27 2.254 18.51C2.254 18.87 2.11 19.122 1.822 19.266C1.81 19.278 1.78 19.29 1.732 19.302C1.684 19.326 1.636 19.344 1.588 19.356L1.534 19.392C1.534 19.404 1.564 19.44 1.624 19.5C1.696 19.56 1.756 19.602 1.804 19.626C1.996 19.77 2.23 19.842 2.506 19.842C2.734 19.842 2.926 19.788 3.082 19.68C3.37 19.512 3.586 19.2 3.73 18.744C3.934 18.168 4.126 16.638 4.306 14.154C4.474 11.874 4.654 9.954 4.846 8.394C5.158 5.958 5.338 4.614 5.386 4.362C5.686 2.634 6.268 1.488 7.132 0.923999C7.432 0.731999 7.762 0.599999 8.122 0.528C8.146 0.528 8.2 0.528 8.284 0.528C8.38 0.515999 8.458 0.509999 8.518 0.509999C9.082 0.545999 9.55 0.743999 9.922 1.104C10.294 1.464 10.48 1.926 10.48 2.49C10.48 2.754 10.396 2.97 10.228 3.138C10.06 3.306 9.85 3.39 9.598 3.39C9.346 3.39 9.136 3.306 8.968 3.138C8.8 2.958 8.716 2.748 8.716 2.508C8.716 2.148 8.86 1.896 9.148 1.752C9.16 1.74 9.19 1.728 9.238 1.716C9.286 1.692 9.328 1.668 9.364 1.644L9.436 1.626C9.436 1.566 9.346 1.488 9.166 1.392C8.962 1.248 8.728 1.176 8.464 1.176C7.936 1.176 7.552 1.488 7.312 2.112C7.168 2.46 7.054 2.94 6.97 3.552C6.898 4.152 6.802 5.256 6.682 6.864C6.514 9.12 6.334 11.034 6.142 12.606C5.902 14.67 5.722 16.014 5.602 16.638C5.254 18.558 4.57 19.77 3.55 20.274C3.238 20.43 2.902 20.508 2.542 20.508C1.678 20.508 1.066 20.136 0.706 19.392C0.562 19.14 0.49 18.852 0.49 18.528C0.49 18.264 0.574 18.048 0.742 17.88Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals4 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-4.5e552a59.svg";
export { ForwardRef as ReactComponent };